export default function (ovrd = {}) {

  const default_state = {
    sort: '_score',
  }

  const default_getters = {
    getCurrentSort(state, getters){
      if(state.sort === '_source') return '_score'
        return state.sort
    },
  }

  const default_mutations = {
    setCurrentSort(state, payload){
      state.sort = payload
    }
  }

  const default_actions = {}

  const default_modules = {}

  const state = (ovrd.state
      ? {...default_state, ...ovrd.state}
      : default_state)
  const getters = (ovrd.getters
      ? {...default_getters, ...ovrd.getters}
      : default_getters)
  const mutations = (ovrd.mutations
      ? {...default_mutations, ...ovrd.mutations}
      : default_mutations)
  const actions = (ovrd.actions
      ? {...default_actions, ...ovrd.actions}
      : default_actions)
  const modules = (ovrd.modules
      ? {...default_modules, ...ovrd.modules}
      : default_modules)

  return {
    namespaced:true,
    state,
    getters,
    mutations,
    actions,
    modules,
  }
}



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/store/modules/persistent/modules/_baseSearchOptions.js